import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { FieldType, FormlyFieldConfig, FormlyFieldProps as CoreFormlyFieldProps, FormlyModule } from '@ngx-formly/core';
import { Checkbox } from 'primeng/checkbox';

interface CheckboxProps extends CoreFormlyFieldProps {
  label?: string;
  binary?: boolean;
}

@Component({
  selector: 'formly-field-primeng-checkbox',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    Checkbox
  ],
  template: `
    <div class="flex align-items-center">
      <p-checkbox
        [id]="id"
        [binary]="true"
        [formControl]="checkboxControl"
        [formlyAttributes]="field"
      ></p-checkbox>
      <label 
        [for]="id" 
        class="ml-2 cursor-pointer"
        *ngIf="props.label"
      >{{ props.label }}</label>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyFieldCheckbox extends FieldType<FormlyFieldConfig<CheckboxProps>> {
  get checkboxControl() {
    return this.formControl as FormControl;
  }
}